<template>
<div @click="playVideo" class="video-box" :class="{header:is_header}">
    <van-image :src="thumb" fit="cover" class="thumb" />
    <img src="@/assets/icon/video_100.png" class="play" />
</div>
</template>
<script>
export default {
   name: 'VideoBox',
   props: {
       is_header:{
           type:Boolean,
           default:false
       },
       thumb: {
           type: String,
           default: ''
       },
       url: {
           type: String,
           default: ''
       }
   },
   methods: {
       playVideo() {
        // 跳转到播放
        this.$router.push({
            path: '/video',
            query:{
                url: this.url
            }
        })
       }
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.video-box {
    position: relative;
    width: rem(300);
    height: rem(300);
}
header {
    position: relative;
    width: 100%;
    height: rem(300);
}

.thumb {
    width: 100%;
    height: 100%;
    background-color: #262626;
}

.play {
    position: absolute;
    width: rem(100);
    height: rem(100);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    opacity: 0.9;
}
.header {
  width: 100%;
  height: rem(320);
}
</style>


// WEBPACK FOOTER //
// src/components/VideoBox.vue